"use client"

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import type { PricingMode } from "./types";

interface PricingSwitchProps {
    onSwitch: (value: string) => void;
    mode: PricingMode;
    showPayg?: boolean;
}

export function PricingSwitch({ onSwitch, mode, showPayg = false }: PricingSwitchProps) {
    return (
        <div className="max-w-full overflow-x-auto pt-[34px] pb-[6px]">
            <Tabs value={mode} onValueChange={onSwitch} className="w-max">
                <TabsList className="flex h-auto gap-1.5 rounded-[14px] bg-[#eceaf7] p-1.5 text-[15px]">
                    <TabsTrigger value="annual" className="h-auto shrink-0 rounded-[10px] px-[22px] py-[11px] font-semibold text-[#5a5f73] hover:bg-white/60 data-[state=active]:bg-white data-[state=active]:text-[#0f1222] data-[state=active]:shadow-[0_1px_4px_rgba(0,0,0,0.08)]">
                        Annual billing <span className="ml-1.5 text-xs font-bold text-[#5b4bff]">Save 20%</span>
                    </TabsTrigger>
                    <TabsTrigger value="monthly" className="h-auto shrink-0 rounded-[10px] px-[22px] py-[11px] font-semibold text-[#5a5f73] hover:bg-white/60 data-[state=active]:bg-white data-[state=active]:text-[#0f1222] data-[state=active]:shadow-[0_1px_4px_rgba(0,0,0,0.08)]">Monthly billing</TabsTrigger>
                    {showPayg && (
                        <TabsTrigger value="payg" className="h-auto shrink-0 rounded-[10px] px-[22px] py-[11px] font-semibold text-[#5a5f73] hover:bg-white/60 data-[state=active]:bg-white data-[state=active]:text-[#0f1222] data-[state=active]:shadow-[0_1px_4px_rgba(0,0,0,0.08)]">Pay As You Go</TabsTrigger>
                    )}
                </TabsList>
            </Tabs>
        </div>
    );
}
